import Tooltip from '../ui-control/Tooltip';
import DemandStudioHeaderButton from '../demand-studio/DemandStudioHeaderButton';
import useLifecareChronologyDownload from '../../hooks/useLifecareChronologyDownload';
import { useDemandStudioContext } from '../../contexts/DemandStudioContext';

const LifecareStudioChronologyDownloadButton = ({ className }) => {
  const { caseId, caseDetails } = useDemandStudioContext();
  const { tooltipTitle, icon, onClick, disabled } = useLifecareChronologyDownload({
    caseId,
    docxFiles: caseDetails?.docxFiles,
  });

  return (
    <Tooltip title={tooltipTitle} placement="bottom" leaveDelay={50}>
      <DemandStudioHeaderButton
        icon={icon}
        label=""
        ariaLabel={tooltipTitle}
        onClick={onClick}
        disabled={disabled}
        className={className}
      />
    </Tooltip>
  );
};

export default LifecareStudioChronologyDownloadButton;
